'use strict';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CAPTCHA_V3_KEY } from 'front_env';
const {
  app
} = window;
let api_url = 'https://www.google.com/recaptcha/api.js?render=' + CAPTCHA_V3_KEY;
export default class Recaptcha extends PureComponent {
  state = {
    id: 'recaptcha-v3'
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    document.body.classList.add('with-recaptcha-v3');
    if (!app.state.recaptchas[state.id]) {
      component.init();
    } else {
      if (app.state.recaptchas[state.id] === 'error') return;
      if (app.state.recaptchas[state.id] === 'init') {
        const script = document.getElementById(state.id);
        script.addEventListener('load', component.executeCaptcha);
      } else if (app.state.recaptchas[state.id] === 'ready') {
        component.executeCaptcha();
      }
    }
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    document.body.classList.remove('with-recaptcha-v3');
  }
  init() {
    const component = this,
      props = this.props,
      state = this.state;
    const script = document.createElement('script');
    script.src = api_url;
    script.id = state.id;
    script.addEventListener('load', function () {
      app.state.recaptchas[state.id] = 'ready';
      if (!window.grecaptcha) return;
      component.executeCaptcha();
    });
    script.addEventListener('onError', function () {
      app.state.recaptchas[state.id] = 'error';
    });
    document.body.appendChild(script);
    app.state.recaptchas[state.id] = 'init';
  }
  executeCaptcha = () => {
    const component = this,
      props = this.props,
      state = this.state;
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute(CAPTCHA_V3_KEY, {
        action: props.name || 'Test'
      }).then(function (token) {
        props.onTokenGeneration(token);
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = null;
    return output;
  }
}
Recaptcha.propTypes = {
  name: PropTypes.string,
  onTokenGeneration: PropTypes.func.isRequired
};
